var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in", appear: "" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentModal,
              expression: "currentModal",
            },
          ],
          staticClass: "modal",
          class: [
            {
              fullscreen: _vm.fullscreen,
              filled: _vm.filled,
              bg: _vm.bg,
              centered: _vm.centered,
            },
            _vm.name + "-outer",
          ],
        },
        [
          _c(
            _vm.name,
            _vm._b(
              {
                tag: "component",
                attrs: {
                  meta: {
                    name: _vm.name,
                    modalId: _vm.modalId,
                    currentModal: _vm.currentModal,
                    fullscreen: _vm.fullscreen,
                    filled: _vm.filled,
                    bg: _vm.bg,
                    centered: _vm.centered,
                  },
                },
              },
              "component",
              _vm.modalData,
              false
            )
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }